import React from 'react';

import { images, data} from '../../constants'
import { SubHeading } from '../../components';

import './SpecialMenu.css';

const SpecialMenu = () => (
  <div className='app__specialMenu flex__center section__padding' id='services'>
    <div className='app__specialMenu-title'>
      <SubHeading title='Things We Do'/>
      <h1 className='headtext__Cormorant'>Services</h1>
    </div>

    <div className='app__specialMenu-menu'>
      <div className='app__specialMenu-menu_wine flex__center'>
        <p className='app__specialMenu-menu_heading'>Project Management</p>
        <div className='app__specialMenu_menu_items'>
          <p className='p__opensans'>
          People often say they wish they'd have known what it was going to 
          take to develop their brand designs and web development projects—if they had, they would’ve chosen differently. 
          That’s where we come in. We can help you make smart decisions from the beginning.

          Our team thinks ahead and asks the right questions, going above and beyond to be a 
          partner you can trust. By getting involved early in the process, we’re able to handle 
          the nuts and bolts of getting a commercially viable web development project off the ground, ensuring the 
          least amount of surprises down the road.
                    </p>
        </div>
      </div>

      <div className='app__specialMenu-menu_img'>
            <img src={images.menu} alt='menu img'/>
      </div>

      <div className='app__specialMenu-menu_cocktails flex__center'>
        <p className='app__specialMenu-menu_heading'>Base Services</p>
        <div className='app__specialMenu_menu_items'>
        <p className='p__opensans'>
        From first contact, it's our goal to put our clients' needs first—listening and valuing your vision above our own egos. 
        It’s our job to understand your unique needs and build the best solution and designs that represent your brand. Our comprehensive commercial architecture design
         services employ industry-leading technologies like Figma, React, Tailwind and Webpacks to help you visualize the end result.
          In-house design and development team help ensure your
         brand is integrated into the design. We are dedicated to delivering the highest quality service—every single time.
                    </p>
        </div>
      </div>
    </div>
  </div>
);

export default SpecialMenu;
